import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'parental-student-grading-scale'
const initialState = {
  gradingScales: null,
}

export const search = createApiAction(
  'academic/student/grading-scale/search',
  client.search('/api/academic/parent/student/:studentId/grading-scale'),
)

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(search.fulfilled, (state, action) => {
      state.gradingScales = action.payload
    })
  },
})

export default sessionSlice.reducer
